export const findMinMax = (arr, key) => {
  let min = arr?.[0]?.[key];
  let max = arr?.[0]?.[key];

  for (let i = 1, len = arr?.length; i < len; i++) {
    const v = arr?.[i]?.[key];
    min = v < min ? v : min;
    max = v > max ? v : max;
  }

  return { min, max };
};

export const IMAGE_FILE_TYPE = ["jpg", "jpeg", "png"];

export const EXCEL_FILE_TYPE = ["doc", "docx", "xlsx", "xls"];

export const PDF_FILE_TYPE = ["pdf"];

export const VIEW_OFFICE_APP_LINK =
  "https://view.officeapps.live.com/op/embed.aspx";
